<template>
  <div class="content">
    <router-link to="/upgrade?from=verification-widget" class="d-block text-center p-1 bg-warning small text-white" v-if="user._id && !user.verified && !user.rejected_reason && user.last_name && user.phone_number && !user.subscription">
      {{ $t('verification_in_progress') }} <i class="fa fa-chevron-right ml-1"></i>
    </router-link>

    <div class="panel-header" :class="{'bg-pro-gradient': user.subscription, 'bg-free-gradient': !user.subscription}">
      <div class="page-inner">
        <!-- DESKTOP -->
        <div class="d-none d-md-block py-5">
          <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
            <div>
              <div :class="{'text-white': user.subscription, 'text-black': !user.subscription}">
                <span class="text-35 pb-2 bold-500 mb-0 dashboard-title" v-if="artists.length">{{ $t('welcome_back') }}, {{ user.name }}</span>
                <span class="text-35 pb-2 bold-500 mb-0 dashboard-title" v-else>{{ $t('hello_there') }}</span>
                <h5 class="mb-2 text-14 bold-400 dashboard-subtitle">
                  <span v-if="published > 1">{{$t('number_published_releases').replace('[total_published]', published)}}</span>
                  <span v-else-if="published === 1">{{$t('number_published_release').replace('[total_published]', published)}}</span>
                  <span v-else>{{ $t('zero_published_releases') }}</span>
                </h5>
              </div>
            </div>
            <div class="ml-md-auto py-2 py-md-0">
              <div v-if="user.active && !user.freeze && artists.length">
                <router-link :to="getNewDistributionUrl()" class="btn btn-gradient btn-lg" v-if="!(strikesCount >= 2 && user.freeze)"><i class="fas fa-plus mr-1"></i> {{ $t('new_release') }}</router-link>
                <button type="button" class="btn btn-gradient btn-lg" @click="showStrikesModal()" v-if="strikesCount >= 2 && user.freeze"><i class="fas fa-plus mr-1"></i> {{ $t('new_release') }}</button>
              </div>
              <div class="card p-3 mb-2 bg-warning text-white" v-if="user.freeze">
                {{ $t('freeze_user_message') }}
              </div>
            </div>
          </div>
        </div>
        <div class="d-md-none py-3">
          <div v-if="user.active && !user.freeze && artists.length" class="mb-3">
            <router-link :to="getNewDistributionUrl()" class="btn btn-block btn-gradient" v-if="strikesCount < 2"><i class="fas fa-plus mr-1"></i> {{ $t('new_release') }}</router-link>
            <button type="button" class="btn btn-gradient btn-block" @click="showStrikesModal()" v-else><i class="fas fa-plus mr-1"></i> {{ $t('new_release') }}</button>
          </div>
          <!-- <ArtistScoreCard v-if="isMobile && user.active && !user.freeze && artists.length"></ArtistScoreCard> -->
        </div>
      </div>
    </div>

    <div class="page-inner mt--4">
      <div class="row">
        <div class="col-12">

          <div class="card firstSteps bg-dark"  v-if="!loadingArtists && !artists.length">
            <img src="/static/img/first-step-background.jpg" alt="first-steps" class="background">
            <div class="top-section">
              <div class="title">{{ $t('first_step_title') }}</div>
              <div class="subtitle">{{ $t('first_step_subtitle') }}</div>
            </div>
            <div class="bottom-left-section">
              <div class="next-step">{{ $t('first_step_next_step') }}</div>
              <div class="create-artist">{{ $t('first_step_create_artist') }}</div>
              <div class="actions">
                <router-link class="btn btn-primary create-artist" to="/new-artist" >{{ $t('first_step_create_artist_2') }}</router-link>
                <router-link class="btn buy-pro" to="/upgrade?from=first_steps_widget" >{{ $t('first_step_buy') }} <span class="text-uppercase">Pro</span></router-link>
              </div>
            </div>
            <div class="bottom-right-section">
              <div class="message">
                {{ $t('first_step_message') }}
              </div>
            </div>
          </div>

          <div class="card" v-if="(user._id && artists.length && !user.verified && !user.rejected_reason && (!user.last_name || !user.phone_number)) || (!user.subscription && !user.phone_number)">
            <div class="card-body">
              <h3>
                <i class="fa fa-exclamation-triangle mr-1 text-warning"></i>
                <span v-if="!user.last_name && !user.phone_number">{{ $t('verify_your_account') }}</span>
                <span v-if="user.last_name || user.phone_number">{{ $t('verification_in_progress') }}</span>
              </h3>
              <p class="mb-0">{{ $t('verify_account_description') }}</p>
              <div class="pull-right d-none d-md-inline mt--5 text-right">
                <button type="button" class="btn btn-default" @click="showVerificationModal()" v-if="!user.last_name || !user.phone_number">
                  {{ $t('verify_now') }}
                </button> <br/>
                <router-link to="/upgrade?from=verification-widget" class="btn btn-gradient mt-2">
                  {{ $t('skip_verification') }}
                </router-link>
              </div>
              <button type="button" class="btn btn-default btn-block d-md-none mt-3" @click="showVerificationModal()" v-if="!user.last_name || !user.phone_number">
                {{ $t('verify_now') }}
              </button>
              <router-link to="/upgrade?from=verification-widget" class="btn btn-gradient btn-block d-md-none mt-2">
                {{ $t('skip_verification') }}
              </router-link>
            </div>
          </div>

          <UpgradeBanner v-if="!user.subscription || (user.subscription && user.subscription.plan_name === 'indiefy_lite')"></UpgradeBanner>
        </div>

        <div class="col-md-4">
          <a href="https://beta.indiefy.net/dashboard" type="button" class="btn btn-warning btn-lg btn-block mb-3">
            Indiefy BETA
          </a>

          <div class="card">
            <div class="card-body">
              <router-link to="/feed" class="btn btn-gray btn-lg btn-block">
                  {{ $t('latest_releases') }}
              </router-link>
              <router-link to="/tools" class="btn btn-gray btn-lg btn-block">
                  {{ $t('extra_tools') }}
              </router-link>
              <a href="https://promo.indiefy.net/" target="_blank" class="btn btn-gray btn-lg btn-block fw-bold">
                {{ $t('music_promotion') }} <i class="fa fa-rocket ml-1 text-primary"></i>
              </a>
            </div>
          </div>
          <div class="card card-dark bg-warning-gradient holidays-banner" v-if="displayNotification">
            <div class="card-body bubble-shadow">
              <h2 class="mb-0">{{ $t('release_date_holidays_title') }}</h2>
              <div class="mb-2"></div>
              <div class="row">
                <div>
                  <div class="text-medium fw-bold op-8 col-12 mb-2 d-flex flex-column align-items-center" v-html="$t('dsp_delivery')"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <ArtistScoreCard v-if="!isMobile && user.active && !user.freeze && artists.length"></ArtistScoreCard> -->
          <LatestPro v-if="!user.subscription && !isMobile"></LatestPro>
          <LatestProReleases v-if="!isMobile"></LatestProReleases>

          <!-- <div class="text-center mb-3 p-2" v-if="!user.subscription && !isMobile">
            <ins class="adsbygoogle"
              style="display:block"
              data-ad-client="ca-pub-8326584585992829"
              data-ad-slot="2819420551"
              data-ad-format="auto"
              data-full-width-responsive="true"></ins>
          </div> -->
        </div>

        <div class="col-md-8">
          <!-- <div class="card">
            <div class="card-body">
              <div>
                <div class="h3">{{ $t('hashtag_of_month') }}:</div>
                <a href="https://www.instagram.com/explore/tags/IndiefyValentines/" target="_blank">#IndiefyValentines</a> <i class="fa fa-heart text-danger ml-1"></i>
              </div>
              <div class="mt-2 mb-2" v-html="`${$t('create_story_hashtag')} 😎`">
              </div>
              <div class="mt-4 row text-center">
                <div class="col-4">
                  <a href="https://facebook.com/indiefyapp" target="_blank" class="btn btn-sm btn-block">
                    <i class="fab fa-facebook mr-1"></i> Facebook
                  </a>
                </div>
                <div class="col-4">
                  <a href="https://instagram.com/indiefyapp" target="_blank" class="btn btn-sm btn-block">
                    <i class="fab fa-instagram mr-1"></i> Instagram
                  </a>
                </div>
                <div class="col-4">
                  <a href="https://tiktok.com/@indiefymusic" target="blank" class="btn btn-sm btn-block">
                    <i class="fa fa-video mr-1"></i> TikTok
                  </a>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <router-link to="/analytics" class="card card-success" v-if="published">
            <div class="card-body">
              <span class="h4 fw-400">🚀 {{ $t('discover_ai_bot') }}</span>
              <span class="new-badge badge badge-danger">NEW</span>
            </div>
          </router-link> -->

          <!-- <router-link to="/tools/spotify-promotion" class="card card-primary">
            <div class="card-body">
              <span class="badge badge-danger badge-beta">NEW</span>
              {{ $t('promote_music_ai') }}
            </div>
          </router-link> -->

          <Playlists></Playlists>

          <!-- Blog Desktop -->
          <div v-if="!isMobile" class="card card-post card-round fadeIn" v-for="(item, index) in posts" v-bind:key="`news_${index}`">
            <router-link :to="`/blog/${item.key}`" class="card-img-preview" :style="`background-image: url(${item.image});`" v-if="item.image"></router-link>
            <div class="card-body">
              <p class="card-category mb-1 mt-0">
                <span class="text-info">Blog</span> - {{ moment.utc(item.publishing_date).format('LL') }}
              </p>
              <h3 class="card-title">
                <router-link :to="`/blog/${item.key}`">
                  <span v-if="lang === 'es'" class="bold-500">
                    {{ item.title_es }}
                  </span>
                  <span v-if="lang !== 'es'" class="bold-500">
                    {{ item.title }}
                  </span>
                </router-link>
              </h3>
              <p class="card-text mt-2">
                <span v-if="lang === 'es'">
                  {{ item.description_es }}
                </span>
                <span v-if="lang !== 'es'">
                  {{ item.description }}
                </span>
              </p>
              <router-link :to="`/blog/${item.key}`" class="btn btn-primary btn-sm">{{ $t('read_more') }}</router-link>
            </div>
          </div>

          <!-- <AIManager v-if="user.active && !user.freeze && artists.length"></AIManager> -->
        </div>
      </div>

      <!-- Latest PRO Artists -->
      <div class="row d-md-none">
        <div class="col-12">
          <div class="d-md-none" v-if="!user.subscription && isMobile">
            <LatestPro></LatestPro>
            <LatestProReleases></LatestProReleases>

            <!-- <div class="text-center mb-3 p-2">
              <ins class="adsbygoogle"
                style="display:block"
                data-ad-client="ca-pub-8326584585992829"
                data-ad-slot="2819420551"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
            </div> -->
          </div>
        </div>
      </div>
      <!-- Desktop -->
      <div class="row">
        <div class="col-md-12">
          <div v-if="isMobile" class="card card-post card-round fadeIn" v-for="(item, index) in posts" v-bind:key="`news_${index}`">
            <router-link :to="`/blog/${item.key}`" class="card-img-preview" :style="`background-image: url(${item.image});`" v-if="item.image"></router-link>
            <div class="card-body">
              <p class="card-category mb-1 mt-0">
                <span class="text-info">Blog</span> - {{ moment.utc(item.publishing_date).format('LL') }}
              </p>
              <h3 class="card-title">
                <router-link :to="`/blog/${item.key}`">
                  <span v-if="lang === 'es'" class="bold-500">
                    {{ item.title_es }}
                  </span>
                  <span v-if="lang !== 'es'" class="bold-500">
                    {{ item.title }}
                  </span>
                </router-link>
              </h3>
              <p class="card-text mt-2">
                <span v-if="lang === 'es'">
                  {{ item.description_es }}
                </span>
                <span v-if="lang !== 'es'">
                  {{ item.description }}
                </span>
              </p>
              <router-link :to="`/blog/${item.key}`" class="btn btn-primary btn-sm">{{ $t('read_more') }}</router-link>
            </div>
          </div>

          <!-- <div class="text-center mt-3 mb-3 p-2" v-if="!user.subscription">
            <ins class="adsbygoogle"
              style="display:block"
              data-ad-client="ca-pub-8326584585992829"
              data-ad-slot="2819420551"
              data-ad-format="auto"
              data-full-width-responsive="true"></ins>
          </div> -->

        </div>
      </div>
    </div>

    <div ref="strikeModal" class="modal light-modal" :class="{'modal-swal modal-h': strikesCount === 1}" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
        <div class="modal-content">
          <div class="modal-body">
            <div class="pt-4 pb-4 title">
              <div v-if="strikesCount === 1 && !user.strike_agree">
                {{ $t('one_strike_title') }}
              </div>
              <div v-if="strikesCount >= 2">
                {{ $t('two_strike_title') }}
              </div>
            </div>
            <div class="description" style="margin-top:40px;">
              <div :class="{'text-warning': strikesCount === 1, 'text-danger': strikesCount >= 2}" style="margin-bottom: 15px;">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div v-if="strikesCount === 1 && !user.strike_agree" class="mt-4 description pr-1 pl-1 text-left" style="word-break: break-all;">
                <div v-html="$t('one_strike_title_text')"></div>
                <div class="custom-control custom-checkbox mt-4 ml-3">
                  <input v-model="strikeAgree" type="checkbox" class="custom-control-input" name="strikeAgree" id="strikeAgree"/>
                  <label class="custom-control-label" for="strikeAgree" v-html="$t('strike_i_acknowledge')"></label>
                </div>
              </div>
              <div v-if="strikesCount >= 2" class="mt-4 description pr-1 pl-1">
                {{$t('two_strike_title_text')}} {{ $t('two_strike_title_text2') }}
              </div>
            </div>
            <div class="mt-4 button-container">
              <button type="button" class="btn btn-primary" data-dismiss="modal" :disabled="strikesCount === 1 && !strikeAgree" @click="saveUserStrikeAgree()">{{ $t('understood') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="verificationModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title text-dark">
              <i class="fas fa-check text-success mr-1"></i>
              {{ $t('request_verification') }}
            </h3>
          </div>
          <div class="modal-body">
            <div class="form-group">
              {{ $t('verification_benefits') }}
            </div>
            <div class="form-group">
              <label for="">{{ $t('name') }}</label>
              <input type="text" class="form-control" v-model="user.name">
            </div>
            <div class="form-group">
              <label for="">{{ $t('last_name') }}</label>
              <input type="text" class="form-control" v-model="user.last_name">
            </div>
            <div class="form-group" v-if="askPhone">
              <label for="">{{ $t('phone_number') }}</label>
              <VuePhoneNumberInput @update="onUpdatePhone" v-bind:default-country-code="defaultCountry" v-model="newPhoneNumber" />
            </div>
            <div class="form-group" v-if="askPhone">
              <label for="">
                {{ $t('preferred_notification_medium') }}
              </label>
              <select class="form-control" v-model="user.preferred_medium">
                <option value="sms">SMS</option>
                <option value="whatsapp">WhatsApp</option>
              </select>
            </div>
            <div class="form-group mt-2">
              <div>
                <i class="fa fa-exclamation-triangle text-warning mr-1"></i>
                {{ $t('our_team_will_review') }}
              </div>
              <div class="mt-2">
                <router-link to="/upgrade?from=verification-widget-immediate" class="btn btn-gradient" data-dismiss="modal">{{ $t('skip_verification') }}</router-link>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal" :disabled="uploadingVerification">{{ $t('cancel') }}</button>
            <button type="button" class="btn btn-success" @click="sendVerification()" :disabled="uploadingVerification">
              <span v-if="!uploadingVerification">{{ $t('send') }}</span>
              <i class="fa fa-spinner fa-spin" v-if="uploadingVerification"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div ref="phoneModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title text-dark">⚡ {{ $t('we_want_to_contact') }} </h3>
          </div>
          <div class="modal-body" v-if="user._id">
            <p>
              {{ $t('hi') }}, {{ $t('we_want_to_contact_description') }}<br/>
            </p>
            <div class="mt-2">
              <VuePhoneNumberInput @update="onUpdatePhone" v-bind:default-country-code="defaultCountry" v-model="newPhoneNumber" />
            </div>
            <p class="text-danger mt-2" v-if="invalidPhone">
              {{ $t('please_type_valid_number') }}
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-dismiss="modal">{{ $t('not_interested') }}</button>
            <button type="button" class="btn btn-success" @click="savePhone()">{{ $t('send') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div ref="modalNewPro" class="modal new-pro-modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <div class="clearfix">
              <div class="col-lg-12 background">
                <div class="logo-title">
                  <img src="/static/img/solo_logo_color.png" >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="pro-title">
                  {{ $t('pro_title') }}
                </div>
              </div>
              <div class="col-lg-8">
                <div class="col-lg-12 pro-description">
                  {{ $t('pro_description') }}
                </div>
                <div class="col-lg-12 text-right pro-buttons">
                  <button class="btn mr-2 btn-default btn-border" data-dismiss="modal" @click="checkNewPro()" :disabled="loading">
                    <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                    {{ $t('continue') }}
                  </button>
                  <a href="https://help.indiefy.net/hc/en-us/articles/360051158334-Why-should-I-have-a-PRO-subscription" class="btn btn-primary" target="_blank">
                    {{ $t('see_my_benefits') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="upgradeModal" class="modal dark-modal w-auto modal-proweekend" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="step = 0">
              <span>×</span>
            </button>
            <div class="mt-5 title-indiefy">Indiefy</div>
            <div class="title">Pro Weekend</div>
            <br><br>
            <div v-if="step === 0">
              <br><br>
              <div class="mt-5 mb-3 text-uppercase description">
                {{ $t('pro_weekends_modal_benefits') }}
              </div>
            </div>
            <div v-if="step === 1">
              <div class="text-uppercase sub-title">
                {{ $t('unlimited_releases') }} <img src="/static/pro-weekend/circle-check-pro-weekend.png" alt="">
              </div>
              <video style="max-width:100%" autoplay loop>
                <source src="/static/pro-weekend/unlimited-releases.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-if="step === 2">
              <div class="text-uppercase sub-title">
                Youtube content ID <img src="/static/pro-weekend/circle-check-pro-weekend.png" alt="">
              </div>
              <video style="max-width:100%" autoplay loop>
                <source src="/static/pro-weekend/youtube-content-id.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-if="step === 3">
              <div class="text-uppercase sub-title">
              +32 {{ $t('exclusives_stores') }} <img src="/static/pro-weekend/circle-check-pro-weekend.png" alt="">
              </div>
              <video style="max-width:100%" autoplay loop>
                <source src="/static/pro-weekend/exclusive-store.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-if="step === 4">
              <div class="text-uppercase sub-title">
                {{ $t('express_deliveries') }} <img src="/static/pro-weekend/circle-check-pro-weekend.png" alt="">
              </div>
              <video style="max-width:100%" autoplay loop>
                <source src="/static/pro-weekend/delivery-express.mp4" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-if="step === 5">
              <br><br>
              <div>{{ $t('enjoy_pro_wekkend') }}</div>
              <br>
              <div class="emoticon">🤟</div>
              <br>
            </div>
            <br>
            <div class="container-buttons">
              <button class="btn btn-gradient" @click="step++" v-if="step <= 4">{{ $t('next') }}</button>
              <button class="btn btn-gradient" @click="activatePass()" v-else :disabled="loadingPro">
                <i v-if="loadingPro" class="fa fa-spinner fa-spin"></i>
                {{ $t('activate') }}
              </button>
              <br>
              <div class="mt-3" v-if="step !== 0">
                {{ step }} of 5
              </div>
            </div>
            <div v-if="step === 0"><br><br><br></div>
            <div v-if="step === 5"><br><br></div>
            <br><br>
            <div class="text-footer mb-4" style="font-weight: 200;">
              {{ $t('pro_weekends_modal_footer') }}
              <a style="font-weight: normal;" href="/pro-weekend">{{ $t('learn_more') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form @submit.prevent="registerHubspot()" name="hubspot-sync-dashboard" id="hubspot-sync-dashboard" style="width: 5px; height: 5px; overflow:hidden;">
      <input type="email" id="hubspot-sync-email-dashboard" name="email">
      <button type="submit" ref="hbSubmit"></button>
    </form>

    <div ref="iosModal" class="modal" tabindex="-1" role="dialog" data-keyboard="false">
      <div class="modal-dialog modal-center">
        <div class="modal-content ios-promo-container">
          <div class="row">
            <div class="col-3 text-center">
              <div>
                <img src="/static/img/logo-colors.png" style="width: 100%;">
              </div>
              <div class="stars">
                <i class="fa fa-star text-muted"></i>
                <i class="fa fa-star text-muted"></i>
                <i class="fa fa-star text-muted"></i>
                <i class="fa fa-star text-muted"></i>
                <i class="fa fa-star text-muted"></i>
              </div>
            </div>
            <div class="col-9">
              <h3>Indiefy Distribution App</h3>
              <div>{{ $t('download_ios_app') }}</div>
            </div>
            <div class="col-12 text-right">
              <div class="mt-4">
                <button type="button" class="btn mr-1" data-dismiss="modal">
                  {{ $t('not_now') }}
                </button>
                <a v-if="isIOS() && lang !== 'es'" target="_blank" href="https://apps.apple.com/us/app/indiefy-music-distribution/id6471776423" type="button" class="btn btn-light">
                  {{ $t('get') }}
                </a>
                <a v-if="isIOS() && lang === 'es'" target="_blank" href="https://apps.apple.com/mx/app/indiefy-music-distribution/id6471776423" type="button" class="btn btn-light">
                  {{ $t('get') }}
                </a>
                <a v-if="isAndroid() && lang !== 'es'" target="_blank" href="https://play.google.com/store/apps/details?id=com.indiefy.distribution&hl=en" type="button" class="btn btn-light">
                  {{ $t('get') }}
                </a>
                <a v-if="isAndroid() && lang === 'es'" target="_blank" href="https://play.google.com/store/apps/details?id=com.indiefy.distribution&hl=es" type="button" class="btn btn-light">
                  {{ $t('get') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TermsAndConditionsUpdate />
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import Filters from '../components/utils/filters'
import Footer from './Footer'
import Blog from '../services/blog'
// import Feed from '../services/feed'
import Upload from '../services/upload'
import countries from '../data/countries'
import Distributions from '../services/distributions'
import User from '../services/user'
import Auth from '../services/auth'
import VuePhoneNumberInput from 'vue-phone-number-input'
import Configuration from '../services/configuration'
import Artists from '../services/artists'
import Analytics from '../services/analytics'
import ServicesOnDemand from '../services/services-on-demand'
import Public from '../services/public'
import LatestPro from '../components/LatestPro'
import LatestProReleases from '../components/LatestProReleases'
import ArtistScoreCard from '../components/ArtistScoreCard'
import AIManager from '../components/AIManager'
import Playlists from '../components/Playlists'
import UpgradeBanner from '../components/UpgradeBanner'
import TermsAndConditionsUpdate from '../components/TermsAndConditionsUpdate'

export default {
  name: 'Dashboard',
  data () {
    return {
      releasesWithLyrics: [],
      loadingArtists: true,
      askPhone: false,
      availableDistributions: 0,
      artists: [],
      mainArtist: {},
      newPhoneNumber: '',
      defaultCountry: 'US',
      locationSettings: {},
      widgetWidth: 0,
      referredPercentage: 1,
      referredFriends: [],
      defaultImage: '/static/img/img-placeholder.jpg',
      user: {},
      lang: 'en',
      // loadingActivity: true,
      moment: moment,
      // activity: [],
      posts: [],
      streamsChart: null,
      mytotalIncomeChart: null,
      strikeAgree: false,
      strikesCount: 0,
      invalidPhone: false,
      embassyReferred: [],
      reviewPaypal: null,
      loading: false,
      published: 0,
      topReleases: [],
      activeProWeekend: false,
      countDown: '',
      step: 0,
      loadingPro: false,
      showBannerHelp: false,
      showBannerNewPrice: false,
      testPayment: false,
      lowstreams: false,
      streamsData: [],
      unverifiedArtist: false,
      streamChart: null,
      streamChart2: null,
      streamGraphType: 'line',
      stripe: {},
      isMobile: false,
      currentData: [],
      loadingData: false,
      currentArtist: {},
      songs: [],
      uploadingVerification: false,
      // gaugeStreamData: {
      //   Weekly: {
      //     canvasId: {
      //       desktop: 'gauge-weekly',
      //       mobile: 'gauge-weekly-mobile'
      //     },
      //     textId: {
      //       desktop: 'gauge-weekly-text',
      //       mobile: 'gauge-weekly-text-mobile'
      //     },
      //     data: [],
      //     total: 0,
      //     date: moment().subtract(9, 'days').format('YYYY-MM-DD')
      //   },
      //   Monthly: {
      //     canvasId: {
      //       desktop: 'gauge-monthly',
      //       mobile: 'gauge-monthly-mobile'
      //     },
      //     textId: {
      //       desktop: 'gauge-monthly-text',
      //       mobile: 'gauge-monthly-text-mobile'
      //     },
      //     data: [],
      //     total: 0,
      //     date: moment().subtract(1, 'month').format('YYYY-MM-DD')
      //   },
      //   Yearly: {
      //     canvasId: {
      //       desktop: 'gauge-yearly',
      //       mobile: 'gauge-yearly-mobile'
      //     },
      //     textId: {
      //       desktop: 'gauge-yearly-text',
      //       mobile: 'gauge-yearly-text-mobile'
      //     },
      //     data: [],
      //     total: 0,
      //     date: moment().subtract(1, 'year').format('YYYY-MM-DD')
      //   }
      // },
      device: 'desktop',
      streamDataMounth: {
        last_month: {},
        this_month: {}
      },
      lastDistro: {},
      displayNotification: false
    }
  },
  methods: {
    isAndroid: function () {
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = ua.indexOf('android') > -1

      return isAndroid
    },
    isIOS () {
      if (typeof window === `undefined` || typeof navigator === `undefined`) return false

      return /iPhone|iPad|iPod/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`))
    },
    checkMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    uploadId: function (callback) {
      let file = this.$refs.photoId && this.$refs.photoId.files[0]

      if (this.user.photo_id) {
        return callback()
      }

      if (!file) {
        this.uploadingVerification = false
        return this.$notify({ message: this.$t('please_select_image') }, 'warning', 'fa-exclamation')
      }

      if (file.name && !file.name.match(/\.jpg$|\.jpeg|\.png/i)) {
        return this.$notify({ message: this.$t('please_select_image') }, 'warning', 'fa-exclamation')
      }

      Upload.uploadImage(file, 'photo-ids').then(response => {
        this.user.photo_id = response.data.full
        callback()
      })
    },
    sendVerification: function () {
      if (!this.user.name) {
        return this.$notify({ message: this.$t('legal_name_required') }, 'warning', 'fa-exclamation')
      }

      if (!this.user.last_name) {
        return this.$notify({ message: this.$t('legal_last_name_required') }, 'warning', 'fa-exclamation')
      }

      if (this.newPhoneNumber && window.$('.input-tel.is-valid').length) {
        this.user.phone_number = this.newPhoneNumber
      }

      if (this.askPhone && !this.user.phone_number) {
        return this.$notify({ message: this.$t('please_type_valid_number') }, 'warning', 'fa-exclamation')
      }

      this.uploadingVerification = true

      let updateObject = {
        name: this.user.name,
        last_name: this.user.last_name,
        approved_on: new Date().toISOString(),
        approved_by: this.user._id
      }

      if (this.askPhone && this.user.phone_number) {
        updateObject.phone_code = this.user.phone_code
        updateObject.phone_number = this.newPhoneNumber || this.user.phone_number
        updateObject.preferred_medium = this.user.preferred_medium
      }

      User.update(updateObject).then(() => {
        this.uploadingVerification = false
        window.$(this.$refs.verificationModal).modal('hide')
        this.$notify({ message: this.$t('account_updated') }, 'success', 'fa-check')
      })
    },
    showVerificationModal: function () {
      window.$(this.$refs.verificationModal).modal('show')
    },
    registerHubspot: function () {
    },
    getNewDistributionUrl () {
      if (!this.artists.length) {
        return `/new-artist?distribution=true`
      }

      if (!this.availableDistributions || (this.locationSettings.hide_basic && !this.user.subscription)) {
        if (this.locationSettings.hide_basic) {
          return `/upgrade?from=dashboard_location_limit`
        } else {
          return `/upgrade?from=dashboard_distro_limit`
        }
      } else {
        return `/new-distribution`
      }
    },
    savePhone: function () {
      const updateObject = {}

      this.invalidPhone = false

      if (this.newPhoneNumber.length && window.$('.input-tel.is-valid').length) {
        updateObject.phone_number = this.newPhoneNumber
        updateObject.phone_code = this.user.phone_code
      } else if (!window.$('.input-tel.is-valid').length) {
        this.$notify({ message: this.$t('please_type_valid_number') }, 'warning', 'fa-exclamation')
        this.invalidPhone = true
        return
      }

      User.update(updateObject).then(response => {
        this.askPhone = false
        window.$(this.$refs.phoneModal).modal('hide')
        this.$notify({ message: this.$t('thank_you_contact_soon') }, 'success', 'fa-check')
      })
    },
    onUpdatePhone: function (ev) {
      this.user.phone_code = '+' + ev.countryCallingCode
    },
    copyReferralLink: function () {
      const el = document.createElement('textarea')
      el.value = `https://indiefy.net/?ref=${this.user._id}`
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$notify({ message: 'Link copied to your clipboard' }, 'success', 'fa-check')
    },
    getCountryCode: function (name) {
      let country = _.find(countries, country => {
        return country.name === name
      })

      if (country) {
        return country.code
      }

      return 'default'
    },
    getDistributionUrl: function (item) {
      if (item.status === 0) {
        if (item._id) {
          return `/distributions/${item._id}`
        } else {
          return `/distributions`
        }
      } else if (item.status === 3) {
        return `/distributions/${item._id}/links`
      } else {
        if (item._id) {
          return `/distributions/${item._id}/details`
        } else {
          return `/distributions`
        }
      }
    },
    validateEmail: function (email) {
      let re = /\S+@\S+\.\S+/
      return re.test(email)
    },
    askForEmail: function () {
      window.swal({
        closeOnClickOutside: false,
        closeOnEsc: false,
        title: this.$t('provide_email'),
        content: {
          element: 'input',
          attributes: {
            placeholder: 'Email',
            type: 'email',
            id: 'email-modal-txt',
            className: 'form-control'
          }
        },
        buttons: {
          cancel: {
            visible: false
          },
          confirm: {
            text: this.$t('save'),
            className: 'btn btn-success'
          }
        }
      }).then(() => {
        if (!window.$('#email-modal-txt').val()) {
          return this.askForEmail()
        }

        if (!this.validateEmail(window.$('#email-modal-txt').val())) {
          return this.askForEmail()
        }

        this.user.email = window.$('#email-modal-txt').val()
        User.update(this.user).then(response => {
          window.swal('', this.$t('thank_you'), 'success')
        }, err => {
          let error = err.response.data.name

          if (error === 'duplicated_email') {
            this.$notify({ message: this.$t('email_registered') }, 'warning', 'fa-exclamation')

            setTimeout(() => {
              this.askForEmail()
            }, 2500)
          }
        })
      })
    },
    setSongtrustVisit: function () {
      window.ga && window.ga('send', {
        hitType: 'event',
        eventCategory: 'Songtrust',
        eventAction: 'Opened',
        eventLabel: 'Songtrust Page Opened'
      })
    },
    saveUserStrikeAgree: function () {
      if (this.strikesCount === 1) {
        User.saveStrikeAgree({ userId: this.user._id }).then({})
      }
    },
    showStrikesModal: function () {
      window.$(this.$refs.strikeModal).modal('show')
    },
    isAmbassador: function () {
      return this.user.role === 'ambassador'
    },
    getEmbassyReferred: function () {
      User.getEmbassyReferred().then((response) => {
        this.embassyReferred = response.data
      }).catch((err) => {
        console.log('Error getting Embassy Referred', err)
      })
    },
    checkNewPro: function () {
      this.loading = true

      User.checkTutorial('new_in_pro').then(response => {
        this.loading = false
        window.$(this.$refs.modalNewPro).modal('hide')
      })
    },
    openModalActivatePass: function () {
      window.$(this.$refs.upgradeModal).modal('show')
    },
    activatePass: function () {
      this.loadingPro = true
      if (this.activeProWeekend) {
        User.activateProWeekend().then(() => {
          location.reload()
        })
      }
    },
    renderStreamsChart: function () {
      if (!this.streamsData.data || !this.streamsData.data[0]) {
        return
      }

      let options = {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        legendCallback: function (chart) {
          let text = []
          text.push('<ul class="' + chart.id + '-legend html-legend">')
          for (let i = 0; i < chart.data.datasets.length; i++) {
            text.push('<li><span style="background-color:' + chart.data.datasets[i].legendColor + '"></span>')
            if (chart.data.datasets[i].label) {
              text.push(chart.data.datasets[i].label)
            }
            text.push('</li>')
          }
          text.push('</ul>')
          return text.join('')
        }
      }

      if (this.streamGraphType === 'line') {
        options.plugins = {
          datalabels: {
            display: false,
            legend: {
              display: false
            },
            labels: {
              render: ''
            },
            formatter: function (value, context) {
              return ''
            },
            backgroundColor: function (context) {
              return ''
            },
            borderRadius: 4,
            color: 'white'
          }
        }

        options.legend = {
          display: false
        }
      } else {
        options.plugins = {
          display: false,
          legend: {
            display: false
          },
          datalabels: {
            formatter: function (value, context) {
              return ''
            },
            backgroundColor: function (context) {
              return ''
            }
          }
        }
      }

      if (this.streamChart) {
        this.streamChart.clear()
        this.streamChart.destroy()
      }

      if (this.streamChart2) {
        this.streamChart2.clear()
        this.streamChart2.destroy()
      }

      window.$('.streamsCanvas').sparkline([102, 109, 120, 99, 110, 105, 115], {
        type: 'line',
        height: '100px',
        width: '100%',
        lineWidth: '2',
        lineColor: '#177dff',
        fillColor: 'rgba(23, 125, 255, 0.14)'
      })

      setTimeout(() => {
        this.$forceUpdate()
      }, 500)
    },
    getStreamsData: function () {
      this.loadingStreams = true

      Analytics.getStreams({
        artist_id: this.lastDistro && this.lastDistro.artist && this.lastDistro.artist.f_id ? this.lastDistro.artist.f_id : '',
        data_type: 'chart',
        from: moment().subtract(9, 'days').format('YYYY-MM-DD'),
        to: moment().subtract(2, 'days').format('YYYY-MM-DD')
      }).then(response => {
        if (response.data.groups) {
          response.data.groups = response.data.groups.slice(0, 5) // Exclude < 30s
        }

        if (response.data.data) {
          response.data.data = response.data.data.slice(0, 5)
        }

        this.streamsData = response.data
        this.loadingStreams = false

        setTimeout(() => {
          if (this.streamsData.data) {
            this.renderStreamsChart()
          }
        }, 1)
      }).catch((err) => {
        this.$notify({ message: this.$t('analytics_temporary_unavailable') }, 'warning', 'fa-exclamation')
        console.log('Error getting streams', err)
      })
    },
    // getStreamsByRange: function (date) {
    //   return Analytics.getStreams({
    //     artist_id: this.lastDistro && this.lastDistro.artist && this.lastDistro.artist.f_id ? this.lastDistro.artist.f_id : '',
    //     data_type: 'list',
    //     type: 'asset',
    //     from: date,
    //     to: moment().subtract(2, 'days').format('YYYY-MM-DD')
    //   })
    // },
    // getStreamsByRangeCustom: function (from, to) {
    //   let id = ''

    //   if (this.lastDistro) {
    //     id = this.lastDistro.f_id
    //   }

    //   return Analytics.getStreamsProduct({
    //     product_id: id,
    //     from: from,
    //     to: to
    //   })
    // },
    // setGaugeData: async function () {
    //   this.loadingData = true

    //   this.gaugeStreamData.Weekly.total = 0
    //   this.gaugeStreamData.Monthly.total = 0
    //   this.gaugeStreamData.Yearly.total = 0

    //   this.getStreamsByRange(this.gaugeStreamData.Yearly.date).then((response) => {
    //     this.gaugeStreamData.Yearly.data = response.data
    //     this.currentData = this.gaugeStreamData.Yearly.data

    //     if (this.currentData.length) {
    //       this.currentData = this.currentData.slice(0, 5)
    //     }
    //     this.loadingData = false
    //   }).catch(e => {
    //     console.error('Error', e)
    //   })

    //   this.getStreamsByRange(this.gaugeStreamData.Monthly.date).then((response) => {
    //     this.gaugeStreamData.Monthly.data = response.data
    //   })

    //   this.getStreamsByRange(this.gaugeStreamData.Weekly.date).then((response) => {
    //     this.gaugeStreamData.Weekly.data = response.data
    //   })

    //   this.getStreamsByRange(this.gaugeStreamData.Weekly.date).then((response) => {
    //     this.gaugeStreamData.Weekly.data = response.data
    //   })
    // },
    buyMastering: function () {
      let priceId = 'price_1LOUjTK9qKRAJ5zqMwKFGV1E'

      ServicesOnDemand.createRequest('62db2b0c0d40961dd460d831').then(response => {
        let urlToSuccess = 'https://' + location.hostname + `${window.apiURL}api/user/services-on-demand/confirm/` + response.data.info
        // eslint-disable-next-line
        if (!!window.location.href.match(/localhost|cms-development|staging/)) {
          console.log(urlToSuccess)
        } else {
          this.stripe.redirectToCheckout({
            lineItems: [{ price: priceId, quantity: 1 }],
            mode: 'payment',
            customerEmail: this.user.email,
            successUrl: urlToSuccess,
            cancelUrl: 'https://' + location.hostname + '/extra-features/?cancelled=1'
          }).then(function (result) {
            console.log(result)
            if (result.error) {
              alert(result.error.message)
            }
          })
        }
      })
    },
    getCover: function (top) {
      if (this.songs.length) {
        let song = _.find(this.songs, song => song.title.toLowerCase() === top.name.toLowerCase())

        if (song) {
          return song.cover
        } else {
          return top.image
        }
      } else {
        return top.image
      }
    },
    numberWithCommas: function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  mounted: async function () {
    window.$('[data-toggle="tooltip"]').tooltip()

    setTimeout(() => {
      window.$('html, body').animate({
        scrollTop: 0
      }, 500)
    }, 50)

    setTimeout(() => {
      window.prerenderReady = true
      if (this.user && this.user.email) {
        window.$('#hubspot-sync-email-dashboard').val(this.user.email).change()
        this.$refs.hbSubmit.click()
      }
    }, 100)

    if (this.user.tutorials && this.user.tutorials['low_streams'] && Math.round(moment(this.user.tutorials['low_streams']).diff(moment().utc(), 'days', true)) >= -7) {
      this.lowstreams = true
    }

    if (!this.user.subscription || (this.user.subscription && this.user.pro_weekend && this.user.pro_weekend === 1)) {
      let promiseConfig = new Promise((resolve, reject) => {
        Configuration.get({fields: ['pro_weekend_active', 'pro_weekend_date_end', 'pro_weekend_date_start']}).then(response => {
          if (response.data.pro_weekend_active) { // temporizador
            resolve(response.data)
          } else {
            resolve(false)
          }
        }).catch(err => {
          reject(new Error(err))
        })
      })
      let promiseNow = new Promise((resolve, reject) => {
        Configuration.now().then(response => {
          if (response.data) { // temporizador
            resolve(response.data)
          } else {
            resolve(false)
          }
        }).catch(err => {
          reject(new Error(err))
        })
      })
      Promise.all([promiseConfig, promiseNow])
        .then(resolveArr => {
          if (!resolveArr[0] || !resolveArr[1]) {
            return false
          }
          let nowServer = moment(resolveArr[1].now_iso)
          let dateStart = moment(resolveArr[0].pro_weekend_date_start)
          let dateEnd = moment(resolveArr[0].pro_weekend_date_end)
          if (nowServer.isBetween(dateStart, dateEnd)) {
            let currentTime = moment(nowServer).unix()
            let eventTime = moment(dateEnd).unix()
            let leftTime = eventTime - currentTime
            let duration = moment.duration(leftTime, 'seconds')
            let interval = 1000
            this.activeProWeekend = true
            if (!this.user.subscription) {
              this.openModalActivatePass() // show modal
            }
            let intervalId = setInterval(() => {
              // Time Out check
              if (duration.asSeconds() <= 0) {
                clearInterval(intervalId)
                this.activeProWeekend = false
              } else {
                duration = moment.duration(duration.asSeconds() - 1, 'seconds')
                let dayTime = String(duration.days()).length === 1 ? '0' + duration.days() : duration.days()
                let hourTime = String(duration.hours()).length === 1 ? '0' + duration.hours() : duration.hours()
                let minutesTime = String(duration.minutes()).length === 1 ? '0' + duration.minutes() : duration.minutes()
                let secondsTime = String(duration.seconds()).length === 1 ? '0' + duration.seconds() : duration.seconds()
                this.countDown = dayTime + 'd ' + hourTime + 'h ' + minutesTime + 'm ' + secondsTime + 's'
              }
            }, interval)
          }
        })
    }

    // setTimeout(() => {
    //   window.$('.carousel-slider-banners').owlCarousel({
    //     autoPlay: true,
    //     navigation: false,
    //     slideSpeed: 300,
    //     pagination: false,
    //     paginationSpeed: 2000,
    //     singleItem: true,
    //     items: 1,
    //     autoHeight: true,
    //     addClassActive: true,
    //     goToFirst: true,
    //     goToFirstSpeed: 200
    //   })
    // }, 300)

    // let thisMonthFrom = moment().startOf('month').format('YYYY-MM-DD')
    // let thisMonthTo = moment().format('YYYY-MM-DD')
    // let lastMonthFrom = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
    // let lastMonthTo = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')

    await Distributions.getAll({ status: [2, 3] }).then(response => {
      let published = _.filter(response.data, item => item.status === 3)

      if (published) {
        this.published = published.length
      }

      if (response.data.length) {
        this.lastDistro = response.data[0]
      }

      this.releasesWithLyrics = _.filter(response.data, item => {
        return item.has_lyrics || _.find(item.songs, song => song.hasLyrics || song.lyrics || song.performance_language !== 'ZXX')
      })
    })

    // this.getStreamsByRangeCustom(thisMonthFrom, thisMonthTo).then((response) => {
    //   this.streamDataMounth.this_month = response.data
    // })

    // this.getStreamsByRangeCustom(lastMonthFrom, lastMonthTo).then((response) => {
    //   this.streamDataMounth.last_month = response.data
    // })

    setTimeout(() => {
      window.$('.carousel-slider').owlCarousel({
        autoPlay: 8000,
        navigation: false,
        slideSpeed: 300,
        pagination: false,
        paginationSpeed: 1000,
        singleItem: true,
        items: 1,
        autoHeight: true,
        addClassActive: true,
        goToFirst: true,
        goToFirstSpeed: 200
      })
    }, 100)

    Configuration.get({fields: ['show_banner_help']}).then(response => {
      this.showBannerHelp = response.data.show_banner_help
    })

    // this.setGaugeData()
    // this.getStreamsData()

    // if (!this.user.subscription) {
    //   setTimeout(() => {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }, 1000)
    // }

    // if ((this.isAndroid() || this.isIOS()) && !localStorage.getItem('iosPromo')) {
    //   window.$(this.$refs.iosModal).modal('show')
    //   localStorage.setItem('iosPromo', 'seen')
    // }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale
    this.isMobile = this.checkMobile()

    window.smartlook && window.smartlook('record', { forms: true, emails: true })

    if (!this.user.phone_number) {
      this.askPhone = true
      this.user.preferred_medium = 'sms'
    }

    if (this.user.tutorials && this.user.tutorials['paypal_removed']) {
      this.reviewPaypal = true
    } else {
      this.reviewPaypal = false
    }

    Distributions.getAvailableDistributions().then(response => {
      this.availableDistributions = response.data.available
    }).catch((error) => {
      console.error('Error while trying to get distribution limit (dashboard)', error)
      this.availableDistributions = 1
    })

    if (this.user.active && !this.user.banned) {
      if (this.isAmbassador()) {
        this.getEmbassyReferred()
      }

      this.group = _.find(this.groups, (group, countryKey) => {
        return countryKey.toLowerCase() === (this.user.country || '').toLowerCase()
      })

      let blogFilter = {
        published: 1,
        limit: 2,
        page: 1
      }

      Blog.getAll(blogFilter).then(response => {
        this.posts = response.data.items
      })

      // Feed.getActivity({ limit: 3 }).then(response => {
      //   this.activity = _.filter(response.data, item => item.distribution)
      //   this.loadingActivity = false
      // })

      this.referredFriends = this.user.referrals_total || 0
      this.referredPercentage = parseInt((this.referredFriends / 5) * 100)

      if (this.referredPercentage >= 98) {
        this.referredPercentage = 100
      } else if (!this.referredPercentage) {
        this.referredPercentage = 1
      }

      if (!this.user.email && this.user.verified) {
        return this.askForEmail()
      }

      Artists.getAll({ limit: 3 }).then((response) => {
        this.loadingArtists = false
        this.artists = response.data
        this.mainArtist = _.max(response.data, item => item.popularity)

        if (this.user.country) {
          this.defaultCountry = this.user.country
        }

        // if (!this.user.phone_number) {
        //   User.checkTutorial('ask_phone_number').then(response => {
        //     if (response.data.show_tutorial) {
        //       window.$(this.$refs.phoneModal).modal('show')
        //     }
        //   })
        // }

        if (!this.user.verified && !this.user.name && this.artists[0] && this.artists[0].legal_name) {
          this.user.name = this.artists[0].legal_name
        }

        if (!this.user.verified && !this.user.last_name && this.artists[0] && this.artists[0].legal_last_name) {
          this.user.last_name = this.artists[0].legal_last_name
        }

        if (this.artists.length && !_.find(this.artists, item => item.verified)) {
          this.unverifiedArtist = true
        }
      })

      Public.getLocationSettings().then(response => {
        this.locationSettings = response.data
      })

      if (this.$route.query.welcome) {
        window.fbq && window.fbq('trackCustom', 'FirstLogin')
      }

      if (this.$route.query.upgrade_success) {
        User.getSubscription().then(response => {
          if (response.data && response.data._id) {
            setTimeout(() => {
              // let value = response.data.cost || 4.16

              // window.fbq && window.fbq('track', 'Subscribe', { currency: 'USD', value })
              window.gtag && window.gtag('event', 'conversion', {'send_to': 'AW-323371496/ZyUMCK-wr_ECEOiDmZoB'})
              window.gtag && window.gtag('event', 'conversion', {'send_to': 'AW-323371496/0WjmCL3ln88YEOiDmZoB'})

              window.gtag && window.gtag('event', `New Subscription`, {
                event_category: 'Subscriptions',
                event_label: 'New Subscription'
              })

              let paymentProperties = {
                type: 'PaymentConfirmed',
                revenue: 999
              }

              window.smartlook && window.smartlook('track', 'Subscription', paymentProperties)

              setTimeout(() => {
                location.href = '/dashboard'
              }, 5000)
            }, 150)
          }
        })
      }

      User.getCurrentStrikes({ userId: this.user._id }).then((response) => {
        this.strikeItems = response.data.length || 0

        User.checkTutorial('show_strike_agree').then(response => {
          if (this.strikesCount >= 2 && this.user.freeze) {
            window.$(this.$refs.strikeModal).modal('show')
          }
        })
      })
    } else {
      Auth.logout().then((response) => {
        window.location.href = '/login'
      })
    }

    User.getNow().then((response) => {
      if (response.data && response.data.now) {
        const serverDate = moment(response.data.now).utc()
        // Setting the comparison dates
        const startDate = moment('2024-11-21').utc()
        const endDate = moment('2024-12-25').utc()
        // Performing the validation
        if (serverDate > startDate && serverDate <= endDate) {
          this.displayNotification = true
        }
      }
    })
  },
  components: {
    Footer,
    VuePhoneNumberInput,
    LatestPro,
    LatestProReleases,
    ArtistScoreCard,
    AIManager,
    Playlists,
    UpgradeBanner,
    TermsAndConditionsUpdate
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style scoped lang="scss">
.quick-container {
  i {
    font-size: 50px;
  }

  .quick-icon {
    position: relative;
    margin-bottom: 15px;
  }

  .quick-label {
    margin-top: -5px;
  }
}
.tools-banner:hover {
  color: white !important;
}
.card-img-preview {
  height: 200px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.songtrust-logo {
  width: 80px;
}

.owl-carousel .owl-item {
  margin: 0 10px
}

.iconplus{
  font-size: 15px;
  padding-right: 5px;
  vertical-align: inherit;
}

.academy-body {
  background: url('/static/img/upgrade-promo.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &.es {
    background: url('/static/img/upgrade-promo-es.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .card-opening, .card-desc {
    text-shadow: 1px 1px 1px #000;
  }
}

.card-upgrade {
  color: transparent;

  .card-opening,
  .card-desc,
  .card-detail {
    opacity: 0;
  }
}

.owl-item .card {
  min-height: 195px;
}

.owl-item .card-dark {
  min-height: 160px;
}

.triangle-icon {
  font-size: 1.6em;
}
.border-banner{
  border-radius: 15px;
}

.block-desktop{
  display: none;
}

.block-mobile{
  display: block;
}

.new-pro-modal {
  .modal-dialog {
    max-width: 740px;
    .modal-body {
      padding: 0;
      .background {
        max-width: 740px;
        min-height: 350px;
        border-top-left-radius: 0.4rem !important;
        border-top-right-radius: 0.4rem;
        /* background: radial-gradient(circle at 50% -20%, #ffffff, #fafafa, #ebebeb, #d6d6d6, #bdbcbd, #a1a0a1, #858485, #6b696b, #555355, #434143, #383638, #343234); */
        background-image: url('/static/img/blog/musical-radar-bg.jpg');
        background-position: center center;
        background-size: cover;

        .logo-title {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          img {
            max-width: 250px;
          }
          span {
            color: #c6c6c6;
            display: inline-block;
            padding-left: 10px;
            font-size: 30px;
            vertical-align: middle;
          }
        }
      }
      .pro-title {
        font-size: 22px;
        font-weight: 700;
        padding: 38px 40px;
      }
      .pro-description {
        padding: 38px 40px 38px 0;
      }
      .pro-buttons{
        padding: 38px 40px 38px 0;
      }
    }
  }
}

.firstSteps {
  position: relative;
  font-family: 'Poppins', sans-serif;
  color: #fff;
  .background {
    width: 100%;
    border-radius: 15px;
    display: block;
  }
  .top-section {
    position: absolute;
    text-transform: uppercase;
    top: 16%;
    left: 4%;
    .title {
      font-size: 72px;
      font-weight: 600;
      line-height: 1;
    }
    .subtitle {
      margin-top: 4px;
      font-size: 18px;
      font-weight: 200;
    }
  }
  .bottom-left-section {
    position: absolute;
    bottom: 16%;
    left: 4%;
    line-height: 1;
    .next-step {
      font-size: 24px;
      font-weight: 600;
      text-transform: uppercase;
    }
    .create-artist {
      font-size: 18px;
      font-weight: 100;
    }
    .actions {
      margin-top: 32px;
      .create-artist {
        background: #E22369 !important;
        border-color: #E22369 !important;
        border-radius: 4px;
        font-size: 15px;
        font-weight: 500;
      }
      .buy-pro {
        background: none;
        color: #fff;
        text-decoration: underline;
        font-size: 16px;
        margin-left: 16px;
      }
    }
  }
  .bottom-right-section {
    position: absolute;
    bottom: 12%;
    right: 4%;
    .message {
      font-size: 24px;
      font-weight: 600;
      text-transform: uppercase;
    }
  }
}

.carousel-item a{
  position: relative;
  display: block;
}

.life {
  position: absolute;
  left: 18px;
  bottom: 10px;
  color: #fff;
  z-index: 2;
  font-size: 30px;
  border: 1px solid #fff;
  border-radius: 50px;
  padding: 0 25px;
  line-height: 40px;
}

.red-circle {
  background: red;
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 50%;
  border: 1px solid #fff;
  margin-left: 10px;
}

.important-notice-modal {
  .modal-dialog {
    max-width: 540px;
  }
  .title {
    font-size: 16px;
    font-weight: 300;
  }
  .description {
    margin-left: 14px;
    margin-right: 14px;
    font-size: 11px;
    font-weight: 300;
    text-align: justify;
    padding: 0 50px;
  }
  .important-notice-agree {
    font-size: 12px !important;
  }
}

.add-script:after {
  content: ' - ';
}

.add-script:last-child:after {
  content: '';
}

.pro-weekend {
  background: url('/static/pro-weekend/banner-pro-week.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 36px 30px;
  color: #fff;
  .element-left {
    text-align: left;
    .title {
      display: inline-block;
      font-size: 26px;
      font-weight: 800;
      color: #000;
      -webkit-text-stroke: 0.5px #fff;
      text-transform: uppercase;
      margin-right: 30px;
      transform: translateY(5px);
    }
    .activate-btn {
      background: #E22369;
      color: #fff;
      &.activated {
        background: #FF6EA3;
        opacity: 1;
      }
    }
  }
  .element-right {
    text-align: right;
    .countdown {
      transform: translateY(5px);
      .numbers {
        font-size: 16px;
      }
      .go-to-prow-landing {
        color: #fff !important;
      }
    }
  }
}

.modal-proweekend {
  .modal-body {
    background: #212529;
    padding: 0px;
    .close {
      color: #fff;
      text-shadow: none;
      padding: 20px;
      position: absolute;
      right: 0;
    }
    .title {
      font-size: 26px;
      font-weight: 800;
      text-transform: uppercase;
      color: #212529;
      -webkit-text-stroke: 0.5px #fff;
    }
    .title-indiefy {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 4px;
      text-transform: uppercase;
    }
    .description {
      font-size: 18px;
      font-weight: 300;
    }
    .sub-title {
      letter-spacing: 4.5px;
      color: #F6E96C;
      background: #5714ff;
      padding: 10px 0;
      img {
        width: 26px;
      }
    }
    .emoticon {
      font-size: 20px;
    }
  }
  .text-footer {
    padding: 0px 70px;
  }
}

.banner-help {
  background: #42bbb9;
  padding-top: 1rem;
  padding-bottom: 1rem;
  .title {
    font-size: 22px;
    color: #fff;
    line-height: 2;
  }
  .go-google {
    min-width: 150px;
  }
}

.banner-new-princing {
  background: #000;
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #fff;
  .close-banner {
    background: none;
    color: white;
    border: none;
    cursor: pointer;
  }
  .message {
    .link {
      color: #fff;
    }
  }
}

.mh-card {
  min-height: 380px;
}

.img-FH {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0.1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

@media screen and (max-width: 1180px) {
  .firstSteps {
    .top-section {
      .title {
        font-size: 42px;
      }
      .subtitle {
        font-size: 14px;
      }
    }
    .bottom-left-section {
      .next-step {
        font-size: 18px;
      }
      .create-artist {
        font-size: 14px;
      }
      .actions {
        margin-top: 12px;
        .btn {
          padding: .4rem 1rem;
        }
        .create-artist {
          font-size: 12px;
        }
        .buy-pro {
          font-size: 12px;
        }
      }
    }
    .bottom-right-section {
      .message {
        font-size: 18px;
      }
    }
  }
}

@media only screen and (max-width: 992px) {
  .new-pro-modal .modal-dialog .modal-body .pro-description {
    padding: 38px 40px;
  }
  .new-pro-modal .modal-dialog .modal-body .pro-buttons {
    padding: 25px 40px;
  }
}

@media screen and (min-width: 991px) {
  .block-desktop{
    display: block;
  }

  .block-mobile{
    display: none;
  }

  .page-inner {
    padding-top: 0px;
  }
}

@media screen and (max-width: 991px) {
  .page-inner {
    padding-top: 0px;
  }
}

@media screen and (max-width: 768px) {
  .dashboard-title {
    line-height: 1.2;
  }
  .dashboard-subtitle {
    margin-top: 14px;
  }
}

@media screen and (max-width: 700px) {
  .firstSteps {
    .top-section {
      top: 20%;
      left: 50%;
      transform: translate(-50%, -50%);
      .title {
        text-align: center;
      }
      .subtitle {
        text-align: center;
      }
    }
    .bottom-left-section {
      bottom: -10%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
    .bottom-right-section {
      display: none;
    }
  }
  .pro-weekend {
    .title {
      text-align: center;
      width: 100%;
    }
    .activate-btn {
      display: block;
      margin: 0 auto;
      margin-top: 20px;
    }
    .element-right {
      text-align: center;
      margin-top: 30px;
      .go-to-prow-landing  {
        display: block;
        margin-top: 20px;
      }
    }
  }
}

.br-head {
  border-radius: 8px 8px 0px 0px;
}

.position-relative {
  position: relative;
}

.img-backtool {
  height: 160px;
  object-fit: cover;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.1;
  border-radius: 10px;
}

@media screen and (max-width: 576px) {
  .firstSteps {
    background: url('/static/img/first-step-background.jpg');
    background-size: cover;
    padding: 20px;
    background-position: center;
    .background {
      display: none;
    }
    .top-section {
      top: initial;
      left: initial;
      transform: initial;
      position: relative;
      z-index: 2;
      .title {
        font-size: 30px;
      }
      .subtitle {
        font-size: 12px;
      }
    }
    .bottom-left-section {
      bottom: initial;
      left: initial;
      transform: initial;
      position: relative;
      z-index: 2;
      margin-top: 20px;
      .next-step {
        font-size: 14px;
      }
      .create-artist {
        font-size: 12px;
      }
      .actions {
        .btn {
          padding: .3rem 0.8rem;
        }
        .create-artist {
          font-size: 10px;
        }
        .buy-pro {
          font-size: 10px;
        }
      }
    }
  }
}

@media screen and (min-width:576px) {
  .hide-mobile {
    display: none !important;
  }
  .new-pro .modal-dialog .modal-body .pro-title {
    padding: 18px 40px;
  }
  .new-pro .modal-dialog .modal-body .pro-description {
    padding: 18px 40px;
  }
  .new-pro .modal-dialog .modal-body .pro-buttons {
    text-align: center !important;
  }
}

@media screen and (max-width: 450px) {
  .firstSteps {
    .top-section {
      .title {
        font-size: 26px;
      }
    }
  }
}

@media screen and (max-width: 400px) {
  .new-pro .modal-dialog .modal-body .pro-title {
    text-align: center;
  }
  .new-pro .modal-dialog .modal-body .pro-description {
    text-align: justify;
  }
  .new-pro .modal-dialog .modal-body .pro-buttons {
    padding: 15px;
  }
}

@media screen and (max-width: 320px) {
  .new-pro .modal-dialog .modal-body .pro-buttons .btn {
    max-width: 140px;
    margin-bottom: 50px;
    font-size: 11px;
  }
}

.carousel-slider-banners i.fa-chevron-right {
  position: absolute;
  right: 13px;
  bottom: 13px;
}

.new-badge {
  position: absolute;
  right: -5px;
  top: -5px;
}

.badge-beta {
  position: absolute;
  top: -5px;
  right: -5px;
}

.card-secondary:hover {
  color: white !important;
}

.ios-app-promo {
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.ios-promo-container {
  border-radius: 8px;
  padding: 20px;
  // width: 90%;
  // position: absolute;
  margin-top: 25%;
  // left: 50%;
  // margin-left: -45%;
  background: #EDF6FF;

  .btn {
    font-size: 16px;
  }

  .btn-light {
    font-weight: bold;
    color: #0A6EF9;
  }

  .stars {
    opacity: 0.8;
    font-size: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue